export default {
  RENAME_LABEL: 'RENAME_WINDOW_LABEL/RENAME_LABEL',
};
